import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import PropTypes from "prop-types";
import { Grid } from "@material-ui/core";
import { useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgress from "components/CircularProgress/CircularProgresss";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import CustomTextField from "components/UpdateUi/CustomeTextField";
import ToastModal from "views/components/ToastModal";

const LenderCreate = (props) => {
  const navigate = useNavigate();
  const params = useParams();
  const [lenderName, setLenderName] = useState("");
  const [lenderNameState, setLenderNameState] = useState(false);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');
  const [redirectURL, setRedirectURL] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  const { classes } = props;

  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
      setToast(showToast);
    if (redirectURL !== "") {
      setRedirectURL("");
      navigate(redirectURL);
    }
  };

  useEffect(() => {
    if (params?.LenderId) {
      getUserData();
    }
  }, [params?.LenderId]);

  const getUserData = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.LENDER_FIND_BY_ID + params?.LenderId,
      authToken: authToken,
    });
    setCallInProgress(false);

    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
      setLenderName(result?.data?.name);
    }
  };

  const isValidated = () => {
    if (lenderName === "") {
      setLenderNameState(true);
      return false;
    } else {
      return true;
    }
  };

  const handleCreateLenderNameSubmit = async (event) => {
    if (isValidated()) {
      toastUpdate("", "", false);
      setCallInProgress(true);
      const res = await apiHandler({
        url: endpoint.LENDER_CREATE,
        method: "POST",
        authToken: authToken,
        data: {
          name: lenderName,
        },
      });
      setCallInProgress(false);
      if (res?.data?.error_code) {
        toastUpdate("Error", res?.data?.user_description, true);
        return;
      } else {
        toastUpdate("Success", "Created Lender successfully", true);

        setRedirectURL(`/coreservice/Lender`);
      }
    }
  };
  const handleEditLenderNameSubmit = async (event) => {
    if (isValidated()) {
      toastUpdate("", "", false);
      setCallInProgress(true);
      const res = await apiHandler({
        url: endpoint.LENDER_UPDATE + params?.LenderId,
        method: "PUT",
        authToken: authToken,
        data: {
          name: lenderName,
        },
      });
      setCallInProgress(false);
      if (res?.data?.error_code) {
        toastUpdate("Error", res?.data?.user_description, true);
        return;
      } else {
        toastUpdate("Success", "Lender Updated Successfully", true); 
        setRedirectURL(`/coreservice/Lender`);
      }
    }
  };
  const handleCancelLender = () => {
    navigate(`/coreservice/Lender`);
  };
  return (
    <Grid container>
      <Grid item xs={12} sm={12} md={12}>
        <SubHeader
          label={params?.LenderId ? "Edit Lender" : "Create Lender"}
          button1=" Save"
          button2=" Cancel"
          button1click={
            params?.LenderId
              ? handleEditLenderNameSubmit
              : handleCreateLenderNameSubmit
          }
          button2click={handleCancelLender}
        />
      </Grid>

      <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
        <Grid container className={classes.inputFieldContainer}>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomTextField
              label="Lender Name"
              required
              error={lenderNameState}
              id="lp_branch_code"
              value={lenderName || ""}
              setState={setLenderName}
            />
          </Grid>
        </Grid>
      </Grid>
      {callInProgress && <CircularProgress callInProgress={callInProgress} />}
      {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}
    </Grid>
  );
};

LenderCreate.propTypes = {
  classes: PropTypes.object,
};

export default LenderCreate;
